/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  arrayOf,
  string,
  number,
  func,
  shape,
  oneOfType,
  bool
} from 'prop-types';
import './autocomplete.scss';
import { ELECTION_NAMES } from '../../constants';

class Autocomplete extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue ? this.getDefaultName() : '',
      hasFocus: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ value: this.getDefaultName() });
    }
  }

  onSelectHandler = (e, select) => {
    if (this.props.onSelect) {
      this.setState({ value: select?.name ?? '' });
      this.props.onSelect(e, select);
    }
  };

  onChangeHandler = event => {
    this.setState({ value: event.target.value, preValue: '' });
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  };

  getDefaultName = () =>
    (
      this.props.results.find(
        e => String(e.ineId) === String(this.props.defaultValue)
      ) || {}
    ).name || '';

  render() {
    const { results, placeholder, showArrow, type, params } = this.props;

    return (
      <div
        className={`autocomplete ${showArrow && `showarrow`} ${this.state.hasFocus ? `open` : ''
          }`}
        onClick={e => {
          if (e.target.nodeName !== 'INPUT') {
            this.setState(prevState => ({ hasFocus: !prevState.hasFocus }));
          }
        }}
      >
        <input
          type="text"
          autoComplete="nope"
          value={this.state.value}
          onChange={e => this.onChangeHandler(e)}
          onFocus={() => {
            this.setState({ hasFocus: true, value: '' });
          }}
          onBlur={() => {
            setTimeout(() => this.setState({ hasFocus: false }), 500);
          }}
          placeholder={!this.state.hasFocus ? placeholder : ''}
        />
        <ul
          className={
            this.state.hasFocus && results ? 'resultList open' : 'resultList'
          }
        >
          {results.map((result, index) => {
            const key = result.ineId + index;
            if (params && type) {
              return (
                <li key={key}>
                  <a
                    href={result.path}
                    target="_parent"
                    title={`Resultado elecciones ${ELECTION_NAMES[type]} ${result.name}`}
                    onClick={e => this.onSelectHandler(e, results[index])}
                    rel="noreferrer"
                  >
                    {result.name}
                  </a>
                </li>
              );
            }
            return <li key={key}>{result.name}</li>;
          })}
        </ul>
        <div className="arrowover" onClick={() => { }} />
      </div>
    );
  }
}

Autocomplete.propTypes = {
  onSelect: func.isRequired,
  showArrow: bool,
  placeholder: string,
  defaultValue: string,
  onChange: func,
  results: arrayOf(shape({ ineId: oneOfType([string, number]), name: string })),
  type: string,
  params: shape({})
};
Autocomplete.defaultProps = {
  showArrow: false,
  placeholder: '',
  defaultValue: '',
  onChange: null,
  results: [],
  type: '',
  params: {}
};

export default Autocomplete;
